import type { TradesResponse } from '../api/client';

interface RecentTradesProps {
  fills: TradesResponse['fills'];
}

function fmtTime(ms: number): string {
  const d = new Date(ms);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())} ${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}`;
}

export function RecentTrades({ fills }: RecentTradesProps) {
  if (!fills || fills.length === 0) {
    return (
      <div className="card" style={{ height: '100%' }}>
        <div className="card-header">
          <span className="card-title">近期成交</span>
        </div>
        <p className="muted" style={{ margin: 0 }}>暂无交易</p>
      </div>
    );
  }

  const recent = fills.slice(0, 15);

  return (
    <div className="card" style={{ height: '100%' }}>
      <div className="card-header">
        <span className="card-title">近期成交</span>
        <span className="label">(最近 {recent.length} 笔)</span>
      </div>
      <div className="trades-table">
        <table className="trade-table">
          <thead>
            <tr>
              <th>时间 (UTC)</th>
              <th>品种</th>
              <th>方向</th>
              <th style={{ textAlign: 'right' }}>netPnl (USD)</th>
            </tr>
          </thead>
          <tbody>
            {recent.map((fill, i) => {
              const netPnl = Number.isFinite(Number(fill.netPnl)) ? Number(fill.netPnl) : 0;
              const pnlColor = netPnl >= 0 ? '#4ade80' : '#f87171';
              const sideColor = fill.side?.toUpperCase() === 'BUY' ? '#4ade80'
                : fill.side?.toUpperCase() === 'SELL' ? '#f87171'
                : undefined;

              return (
                <tr key={`${fill.time}-${fill.coin}-${i}`}>
                  <td style={{ fontSize: '0.78rem', color: 'rgba(255,255,255,0.5)' }}>
                    {fmtTime(fill.time)}
                  </td>
                  <td style={{ fontWeight: 600 }}>{fill.coin}</td>
                  <td style={{ color: sideColor, fontWeight: 600, fontSize: '0.8rem' }}>
                    {fill.side}
                  </td>
                  <td className="text-right" style={{ color: pnlColor, fontWeight: 600 }}>
                    {netPnl >= 0 ? '+' : ''}{netPnl.toFixed(2)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
